if (!window.Eurus.loadedScript.has('dark-mode.js')) {
  window.Eurus.loadedScript.add('dark-mode.js');
  
  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => { 
      Alpine.store('xDarkMode', {
        alias: "btn-theme-mode",
        // Storage can be unavailable or read-only (private browsing, in-app
        // webviews, partitioned iframes, full quota). Writing it first meant a
        // throw aborted the whole handler and the theme never switched, leaving
        // the page stuck on whatever it already showed. Switch first, persist after.
        persist(value) {
          try {
            localStorage.eurus_theme = value;
          } catch (e) {
            // preference just won't survive the next page load
          }
        },
        toggleThemeMode() {
          Alpine.store('xDOM').rePainting = this.alias;
          setTimeout(() => {
            try {
              if (document.documentElement.classList.contains('dark')) {
                document.documentElement.classList.remove('dark');
                this.persist(0);
              } else {
                document.documentElement.classList.add('dark');
                this.persist(1);
              }
              Alpine.store('pseudoIconTheme').updatePseudoIconInputTheme();
            } finally {
              Alpine.store('xDOM').rePainting = null;
            }
          }, 200); // INP
        },
        toggleLightMode() {
          Alpine.store('xDOM').rePainting = this.alias;
          setTimeout(() => {
            try {
              document.documentElement.classList.remove('dark');
              this.persist(0);
              Alpine.store('pseudoIconTheme').updatePseudoIconInputTheme();
            } finally {
              Alpine.store('xDOM').rePainting = null;
            }
          }, 200); // INP
        },
        toggleDarkMode() {
          Alpine.store('xDOM').rePainting = this.alias;
          setTimeout(() => {
            try {
              document.documentElement.classList.add('dark');
              this.persist(1);
              Alpine.store('pseudoIconTheme').updatePseudoIconInputTheme();
            } finally {
              Alpine.store('xDOM').rePainting = null;
            }
          }, 200); // INP
        }
      });
      Alpine.store('pseudoIconTheme', {
        init() {
          this.updatePseudoIconInputTheme();
        },
        updatePseudoIconInputTheme() {
          let themeMode = null;
          try {
            themeMode = localStorage.getItem('eurus_theme');
          } catch (e) {
            // unreadable storage - fall back to what the document is actually showing
          }
          if (themeMode === null) {
            themeMode = document.documentElement.classList.contains('dark') ? '1' : '0';
          }
          document.querySelectorAll('input[type="date"], input[type="time"]').forEach(input => {
            if (themeMode === '1') {
              input.style.colorScheme = 'dark';
            } else {
              input.removeAttribute('style');
            }
          });
        }      
      });
    })
  })
}